'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _nestedtypes = require('nestedtypes');

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _nestedHateoasCommonModels = require('@unitedtraders/nested-hateoas-common-models');

var _nestedHateoas = require('@unitedtraders/nested-hateoas');

var _Market = require('./enums/Market');

var _Market2 = _interopRequireDefault(_Market);

var _WithdrawRequestStatus = require('./enums/WithdrawRequestStatus');

var _WithdrawRequestStatus2 = _interopRequireDefault(_WithdrawRequestStatus);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function WithdrawRequest(domainBuilder) {
  domainBuilder.defineModel('WithdrawRequest', 'witdrawRequest', function (model) {
    return model.define({
      defaults: {
        id: Number.value(null),
        user: _nestedHateoasCommonModels.LunaUser.value(null),
        market: _Market2.default.factory.value(null),
        amount: _nestedHateoasCommonModels.MoneyModel.value(null),
        state: _WithdrawRequestStatus2.default.factory.value(null),
        rejectCause: String.value(null),
        createdBy: _nestedHateoasCommonModels.LunaUser.value(null),
        updatedBy: _nestedHateoasCommonModels.LunaUser.value(null),
        createdAt: Date.value(null),
        updatedAt: Date.value(null)
      }
    });
  }).defineSearchMethod({
    name: 'getWithdrawRequests',
    overrideUrl: 'api/me/account/withdraw-requests',
    query: _nestedtypes.Model.extend({
      defaults: {
        from: Date.value(null),
        to: Date.value(null),
        state: _WithdrawRequestStatus2.default.factory.value(null),
        market: _Market2.default.factory.value(null)
      },
      getQueryPart: function getQueryPart() {
        var params = { states: [] };
        if (this.from) {
          params.from = (0, _moment2.default)(this.from).format();
        }
        if (this.to) {
          params.to = (0, _moment2.default)(this.to).format();
        }
        if (this.market) {
          params.markets = this.market.name;
        }
        if (this.state) {
          params.states = [this.state.name];
        }
        return (0, _nestedHateoas.hash2query)(params);
      }
    }),
    additionalInfo: _nestedtypes.Model.extend({
      defaults: {
        summary: _nestedtypes.Model.extend({
          defaults: {
            amounts: _nestedHateoasCommonModels.MoneyModel.Collection
          }
        })
      }
    })
  }).defineSearchMethod({
    name: 'getWithdrawRequestsAsAdmin',
    overrideUrl: 'api/admin/account/withdraw-requests',
    query: _nestedtypes.Model.extend({
      defaults: {
        user: String.value(null), // LunaUser
        state: _WithdrawRequestStatus2.default.factory.value(null),
        from: Date.value(null),
        to: Date.value(null)
      },
      getQueryPart: function getQueryPart() {
        var params = { states: [] };
        if (this.user) {
          params.user = this.user;
        }
        if (this.from) {
          params.from = (0, _moment2.default)(this.from).format();
        }
        if (this.to) {
          params.to = (0, _moment2.default)(this.to).format();
        }
        if (this.state) {
          params.states = [this.state.name];
        }
        return (0, _nestedHateoas.hash2query)(params);
      }
    })
  });
}

exports.default = WithdrawRequest;


//////////////////
// WEBPACK FOOTER
// ./~/@unitedtraders/statements-domain/dist/models/WithdrawRequest.js
// module id = 1436
// module chunks = 118